import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  gap: 0.25rem;
  justify-content: center;
  align-items: center;
  width: fit-content;
  max-width: inherit;
  height: 2rem;
  border-radius: 2rem;
  flex-shrink: 0;
  padding: 0 0.625rem;
  color: var(--text-tertiary);
  font-size: 0.875rem;
  font-weight: 500;

  > span {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .material-symbols-rounded {
    font-size: 1.125rem;
    font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
  }
  &.small {
    height: 1.5rem;
    gap: 0.125rem;
    white-space: nowrap;
  }
  .blue {
    background-color: var(--tonal-blue);
    color: var(--primary);
    &:hover {
      background-color: var(--tonal-deep-blue);
    }
    &.light {
      background-color: #eef2ff;
      color: var(--blue-500);
      &:hover {
        background-color: var(--indigo-100);
      }
    }
    &.dark {
      background-color: #212e48;
      background-color: var(--sky-900);
      color: var(--blue-400);
      &:hover {
        background-color: var(--sky-800);
      }
    }
  }
  .red {
    background-color: var(--tonal-red);
    color: var(--filled-red);
    &:hover {
      background-color: var(--tonal-deep-red);
    }
    &.light {
      background-color: #fff5f8;
      color: var(--rose-500);
      &:hover {
        background-color: var(--red-100);
      }
    }
    &.dark {
      background-color: #3a2434;
      color: var(--rose-500);
      &:hover {
        background-color: var(--red-900);
      }
    }
  }

  &.badge {
    font-weight: 500;
    font-size: 0.875rem;
    padding: 0.125rem 0.5rem;
    border-radius: 0.25rem;
    margin: 0 0.5rem;
    min-width: 1.75rem;
    text-align: center;
  }

  &.blue {
    color: var(--primary);
    background-color: var(--tonal-blue);
  }

  &.red {
    color: var(--filled-red);
    background-color: var(--tonal-red);
  }

  &.violet {
    color: var(--filled-violet);
    background-color: var(--tonal-violet);
  }

  &.orange {
    color: var(--filled-orange);
    background-color: var(--tonal-orange);
  }

  &.green {
    color: var(--filled-green);
    background-color: var(--tonal-green);
  }

  &.amber {
    color: var(--filled-amber);
    background-color: var(--tonal-amber);
  }

  &.slate {
    color: var(--filled-slate);
    background-color: var(--tonal);
  }
`;

type Props = {
  icon?: string;
  text: string;
  color?: 'blue' | 'red' | 'violet' | 'orange' | 'green' | 'amber' | 'slate' | '';
  size?: 'small';
  fixTheme?: 'dark' | 'light';
};

const SmallTextLabel = ({ icon, text, color, size, fixTheme }: Props) => {
  const { t } = useTranslation();
  const style = () => {
    return `${color ? `badge ${color}` : ''} ${size ?? ''} ${fixTheme ?? ''}`;
  };
  return (
    <Root className={style()}>
      {icon && <span className='material-symbols-rounded'>{icon}</span>}
      <span>{t(text)}</span>
    </Root>
  );
};

export default SmallTextLabel;
